// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3SBS_","checkboxCol":"Table_checkboxCol__20-tv","emailCol":"Table_emailCol__htaBs","actionCol":"Table_actionCol__18odK"};